export default __webpack_public_path__ + "static/media/onurbelgesi2.87abf019.jpg";